import { createWebHistory, createRouter } from 'vue-router'

const routes = [
  {
    path: '/game/:roomId',
    name: 'Game',
    component: () => import(/* webpackChunkName: "pages/Game" */ '@/pages/Game'),
  },
  {
    path: '/create',
    name: 'PreGame',
    component: () => import(/* webpackChunkName: "pages/PreGame" */ '@/pages/PreGame'),
  },
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "pages/Home" */ '@/pages/Home'),
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

export default router
